import { Component, EventEmitter, Input, OnInit, Output, forwardRef, OnChanges } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SearchableSelectModalComponent } from './searchable-select-modal/searchable-select-modal.component';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormControl } from '@angular/forms';


@Component({
  selector: 'app-searchable-select',
  templateUrl: './searchable-select.component.html',
  styleUrls: ['./searchable-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SearchableSelectComponent),
      multi: true
    }
  ]
})
export class SearchableSelectComponent implements OnInit, ControlValueAccessor {

  @Input() options: Array<string>;
  @Input() selectedOptions: Array<string> = [];

  /** Optional section headers for the modal; flat list when omitted. */
  @Input() groups: Array<{ label: string; options: string[] }>;

  @Input() multiple : Boolean = false;
  @Input() labelText: string = '';
  @Output() onSelect : EventEmitter<Array<String>> = new EventEmitter();
  @Input() control: FormControl;
  alertController: HTMLIonModalElement;

  placeHolderText: string = "Select Sub Skill";
  
  originalSelectedOptions;
  _subSkills: string[];
  propagateChange = (_: any) => {};
  propagateTouched = (_: any) => {};

  constructor( private modalController: ModalController){
  }

  get subSkills(): any {
    return this._subSkills;
  }

  set subSkills(value:  any) {
    this._subSkills = value;
    this.onSelect.emit(this._subSkills);
    this.propagateChange(this._subSkills);
  }

  ngOnInit() {
    this.originalSelectedOptions = this.multiple ? [...this.selectedOptions] : this.selectedOptions;
  }

  ngOnChanges() {

    

    if(!this.multiple) {
      this.originalSelectedOptions = this.selectedOptions;
      this.placeHolderText = this.originalSelectedOptions;
    }

    if(this.multiple && !this.selectedOptions?.length || (this.control && this.control.pristine && !this.control.value.length)) {
      this.placeHolderText= "Select Sub Skill"
      this.originalSelectedOptions = [...this.selectedOptions];
    }

    if(this.selectedOptions?.length >= 1 && this.labelText === 'Sub skills') { 
      this.handleSelect(this.selectedOptions);  
    }

  }
  /**
   * 
   * @param selectedOptions 
   * @description this function handle when select button is called
   */

  /**
   * What the closed control shows.
   *
   * Joining every value with commas overflowed the field as soon as two were
   * picked — and these values are long ("SUNNYBROOK General Trained"). For a
   * multi-select the values are listed as chips underneath, so the control
   * itself only needs to report how many there are.
   */
  summariseSelection(selectedOptions: Array<string>): string {
    if (!selectedOptions || !selectedOptions.length) {
      return 'Select Sub Skill';
    }
    if (!this.multiple) {
      return selectedOptions[0];
    }
    return selectedOptions.length === 1 ? '1 selected' : selectedOptions.length + ' selected';
  }

  /** The selected values, shown as removable chips under a multi-select. */
  get chips(): string[] {
    return this.multiple ? (this.originalSelectedOptions || []) : [];
  }

  /** Remove one value without reopening the picker. */
  removeOption(option: string, event?: Event) {
    // The chip sits inside the control; without this the click also opens the
    // picker the user is trying to edit around.
    event?.stopPropagation();
    const remaining = (this.originalSelectedOptions || []).filter((o) => o !== option);
    this.selectedOptions = remaining;
    this.handleSelect(remaining);
  }

  async handleSelect(selectedOptions: Array<string>){
      this.placeHolderText = this.summariseSelection(selectedOptions);
      this.originalSelectedOptions = [ ...selectedOptions ];
      
      this.onSelect.emit(selectedOptions);
      this.subSkills = selectedOptions;

      if(this.alertController) {
        await this.alertController.dismiss()
      }
      
  }


  /**
   * this function handle the cancel button and dismiss the modal
   */

  async handleCancel(){

    if(!this.multiple) {
      this.selectedOptions = this.originalSelectedOptions;
      await this.alertController.dismiss();
      return;
    }
    this.selectedOptions = [...this.originalSelectedOptions];
    this.subSkills = this.selectedOptions;
    await this.alertController.dismiss()
  }


  /**
   * @descripiton this function init the searchable select modal
   */

  async handleSubSkillDropDownClick(){
    
    if(this.alertController){
      await this.alertController.dismiss()
    }

    this.alertController = await this.modalController.create({
      component: SearchableSelectModalComponent,
      backdropDismiss: false,
      cssClass: 'searchable-select-modal',
      componentProps:{
        options: this.options,
        groups: this.groups,
        labelText: this.labelText,
        selectedOptions: this.selectedOptions,
        onCancel: this.handleCancel.bind(this),
        multiple: this.multiple,
        onSelect: this.handleSelect.bind(this)
      }
  });

    await this.alertController.present();
  }


  //Form Accessor Functions for custom components
  writeValue(value: any): void {
    this._subSkills = value;
  }
  

  registerOnChange(fn: (value: any) => void): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.propagateTouched = fn;
  }
 


}
